module.exports = __webpack_public_path__ + "img/33_70.4af3c565.png";